<script lang="typescript">
  import type { User } from '../../common/types';
  import { useMachine } from '../../common/myrobot';
  import Panel from '../../common/Panel.svelte';
  import { create } from './addsupervisor';
  export let users:Array<User>;
  const machine = create();
  const { state, context, send } = useMachine(machine);
  const save = () => send('save');
  $:non_supervisors = users.filter( u => !u.is_supervisor );
  $:all_users_added = non_supervisors.length == 0;
  $:values = $context.values;
  $:isSaving = $state == "saving";
  $:error = $context.error;
  $:disabled = isSaving;
</script>

<div>
  <h2>Lisää ohjaajan tiedot</h2>
  {#if all_users_added}
    <p>Kaikki käyttäjät on jo asetettu ohjaajiksi</p>
  {:else}
    <form id="new-supervisor" on:submit|preventDefault={save}>
      <p>
      <label for="user-id">Ohjaajan tunniste (numero)</label>
      <select required bind:value={values.user_id} name="user-id" id="user-id">
        {#each non_supervisors as user}
          <option value={user.id}>
          {user.name} ({user.id})
          </option>
        {/each}
      </select>
      </p>
      <p>
      <label for="name">Ohjaajan kutsumanimi (näkyy ostoskorissa)</label>
      <input required bind:value={values.name} name="name" id="name" type=text>
      </p>
      <p>
      <label for="thumbnail-id">Ohjaajan kuvan id (numero)</label>
      <input required bind:value={values.thumbnail_id} name="thumbnail-id" id="thumbnail-id" type=number>
      </p>
      {#if isSaving}
        <p>
        <i class="fas fa-spinner fa-spin fa-lg"></i> Tallennetaan...
        </p>
      {/if}
      <p>
      <input {disabled} type=submit value="Lisää ohjaaja">
      </p>
    </form>
  {/if}
  {#if error}
    <Panel type="error">
      <p>Virhe ohjaajan lisäyksessä.</p>
      <div>
      {@html error}
      </div>
    </Panel>
  {/if}
</div>

<style>
  label {
    display: block;
  }
</style>

